'use client';

import { ReactNode } from 'react';
import { usePinAdToBottomStore } from '@fe-news/context/pin-ad-to-bottom-zustand';
import { useShallow } from 'zustand/react/shallow';

interface ShowBottomAdTriggeredByScrollInViewProps {
  children?: ReactNode;
}

const ShowBottomAdTriggeredByScrollInView = ({ children }: ShowBottomAdTriggeredByScrollInViewProps) => {
  const { isShow } = usePinAdToBottomStore(
    useShallow(state => ({
      isShow: state.isShow
    }))
  );

  return isShow ? children : null;
};

export default ShowBottomAdTriggeredByScrollInView;
